<mat-form-field *ngIf="control" class="app-datepicker">
  <mat-label>{{label}}</mat-label>
  <input matInput [matDatepicker]="dp" [formControl]="control" [required]="required"
         [placeholder]="placeholder" [min]="minDate === null ? undefined : minDate"
         [max]="maxDate === null ? undefined : maxDate"
         [matDatepickerFilter]="dateFilter ? dateFilter : undefined"
         autocomplete="off">
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <button *ngIf="control.value && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-datepicker #dp></mat-datepicker>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
